import React, {useState} from "react";
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

export default function ToastNotification(display){

  const [Show, setShow] = useState(false);

  return (
    <ToastContainer
      className="position-absolute p-1 "
      position="top-end"
    >
      <Toast onClose={() => setShow(false)} show={Show} delay={10000} autohide>
        <Toast.Header>
          <strong className="me-auto">Change Title here: </strong>
        </Toast.Header>
        <Toast.Body>You've successfully added Stock</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}
